import * as z from "zod";

export const AskRedoCesOutcomeSchema = z.enum(["shown", "dismissed", "scored"]);

/** `responseId` is the row's int8 id as a decimal string. */
const askRedoCesResponseOutput = z.object({
  responseId: z.string(),
  outcome: AskRedoCesOutcomeSchema,
});

/**
 * Whether to show the survey after this reply on the caller's own web thread.
 * Never writes. `replyNumber` counts the thread's finished AI replies, from 1.
 */
export const getAskRedoCesEligibility = {
  name: "getAskRedoCesEligibility" as const,
  input: z.object({
    threadId: z.string(),
    replyNumber: z.number().int().min(1),
  }),
  output: z.object({ show: z.boolean() }),
};

/** The survey shown on the caller's own web thread; one row per thread. */
export const recordAskRedoCesShown = {
  name: "recordAskRedoCesShown" as const,
  input: z.object({ threadId: z.string() }),
  output: z.object({ responseId: z.string() }),
};

export const submitAskRedoCesScore = {
  name: "submitAskRedoCesScore" as const,
  input: z.object({
    responseId: z.string(),
    score: z.number().int().min(1).max(5),
  }),
  output: askRedoCesResponseOutput,
};

export const submitAskRedoCesComment = {
  name: "submitAskRedoCesComment" as const,
  input: z.object({
    responseId: z.string(),
    comment: z.string().trim().min(1).max(2000),
  }),
  output: askRedoCesResponseOutput,
};

export const dismissAskRedoCes = {
  name: "dismissAskRedoCes" as const,
  input: z.object({ responseId: z.string() }),
  output: askRedoCesResponseOutput,
};
